import { render, staticRenderFns } from "./vehicleRoute.vue?vue&type=template&id=6274d6ea&"
import script from "./vehicleRoute.vue?vue&type=script&lang=js&"
export * from "./vehicleRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports